import { render, staticRenderFns } from "./AllocationEdit.vue?vue&type=template&id=155e2f26"
import script from "./AllocationEdit.vue?vue&type=script&lang=js"
export * from "./AllocationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports